import React, { useState, useContext } from 'react';
import { Button, Modal }      from 'react-bootstrap';
import { AuthContext } from './AuthContext';

const LogoutModal = ({ isOpen, onClose }) => {
  const [message, setMessage] = useState('');
  const { logout } = useContext(AuthContext);
  
  const handleLogout = async () => {
    // Call login API provided by AuthContext
    const response = await logout( );
    console.log("Logout response = " + response );
    if (response.success) {
        onClose(); // Close the modal after login
    } else {
        setMessage( "Login failed: " + response.message );
    }
  };
  
  if (!isOpen) return null; // Don't render the modal if it's not open

  return (
    <Modal show={ true } backdrop="static">
      <Modal.Header>
        <Modal.Title>Log Out</Modal.Title>
      </Modal.Header>
      <Modal.Body>
         <Button variant="primary" size="sm" onClick={handleLogout}>Confirm Logout</Button>      </Modal.Body>
      <Modal.Footer>
      
        <Button variant="primary" size="sm" onClick={onClose}>Cancel</Button>
        <p>{ message }</p>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoutModal;
